module.exports = __webpack_public_path__ + "static/media/shattered-logo.dd589d2d.png";